<template>
  <div>
    <div v-for="(item, index) in items" class="cart__item">
      <div class="remove">
        <button @click="removeLine(item.rowId)" class="btn" type="button">
          <i class="fas fa-times"></i><span class="sr-only">Remove product {{ item.name }}</span>
        </button>
      </div>
      <div class="image" v-if="item.options.image_url">
        <a :href="item.options.permalink || 'javascript:;'" target="_blank" tabindex="-1">
          <img :src="item.options.image_url" :alt="item.name"></a>
      </div>
      <div class="name">
        <a :href="item.options.permalink || 'javascript:;'" target="_blank">
          <div>
            <span>{{ item.name }}</span>
            <div v-if="item.options.on_demand_options" class="demand-options">
              <span v-if="item.options.on_demand_options.playerName">
                Player Name: {{ item.options.on_demand_options.playerName }}
              </span>
              <span v-if="item.options.on_demand_options.playerNumber">
                Player Number: {{ item.options.on_demand_options.playerNumber }}
              </span>
              <span v-if="item.options.on_demand_options.playerCA">
                Player CA: {{ item.options.on_demand_options.playerCA }}
              </span>
            </div>
          </div>
          <div v-if="item.options && item.options.product_options" class="options">
            <ul>
              <li v-for="option in item.options.product_options"><strong>
                {{ option.name }}:</strong> {{ option.value }}
              </li>
            </ul>
          </div>
          <div class="options" v-if="item.options.is_gift_certificate">
            <ul>
              <li><strong>To:</strong> {{ item.options.email }}</li>
              <li><strong>Name:</strong> {{ item.options.first_name + ' ' + item.options.last_name }}
              </li>
              <li><strong>Message:</strong> {{ item.options.message }}</li>
            </ul>
          </div>
        </a>
      </div>
      <div class="qty">
        <label :for="'decrease_qty' + item.rowId">QTY</label>
        <div class="form-control">
          <div class="form-control">
            <label class="sr-only" :for="'decrease_qty' + item.rowId">Decrease product quantity. Current
              quantity: {{ item.qty }}</label>
            <button @click="item.qty--; updateLineQuantity(item.qty, item.rowId, -1)"
                    :id="'decrease_qty' + item.rowId"
                    class="minus"
                    type="button"
                    :arial-labelledby="'decrease_qty' + item.rowId"
                    :disabled="
                      item.qty <= 1
                      || !isCheckoutLoaded
                      || !isTaxesCalculated
                      || isLoadingTaxes
                    ">-
            </button>
            <label :for="'productQuantity' + item.rowId" class="sr-only">Product Quantity</label>
            <input :value="item.qty" disabled="disabled" type="number" :id="'productQuantity' + item.rowId">
            <label class="sr-only" :for="'increase_qty' + item.rowId">Increase product quantity. Current
              quantity: {{ item.qty }}</label>
            <button @click="item.qty++; updateLineQuantity(item.qty, item.rowId, 1)"
                    :id="'increase_qty' + item.rowId"
                    class="plus"
                    type="button"
                    :arial-labelledby="'increase_qty' + item.rowId"
                    :disabled="
                      (item.max_qty <= item.qty && item.max_qty !== -1)
                      || !isCheckoutLoaded
                      || !isTaxesCalculated
                      || isLoadingTaxes
                    ">+
            </button>
          </div>
        </div>
      </div>
      <div class="price">
        <span>${{ item.price }}</span>
        <span v-if="item.options.old_price" class="has_discount">${{ item.options.old_price }}</span>
      </div>
      <div v-if="item.options.comment" class="comments">
        <span>Comment:</span>
        <span>{{ item.options.comment }}</span>
      </div>
      <div v-if="item.options.shipping_type === 'pickup'" class="alert alert-info">
        Pick up at {{ item.warehouse }}
      </div>
      <div v-if="item.low_stock > 0" class="alert alert-warning">
        Only {{ item.low_stock }} items left
      </div>
      <div v-if="!item.is_discountable" class="alert alert-warning">
        This product is not available for discounts or promotions
      </div>
      <div v-if="item.out_of_stock && item.low_stock <= 0" class="alert alert-danger">Out of Stock</div>
      <div v-if="item.out_of_stock && item.low_stock >= 0" class="alert alert-danger">Not enough stock</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CheckoutApi from '@support/checkoutApi'
import sendEventsMixin from "@mixins/sendEventsMixin";

export default Vue.extend({
  name: "cartProducts",
  mixins: [sendEventsMixin],
  data() {
    return {
      cancel: null,
      itemUpdateQueue: {}
    }
  },
  created() {
    this.$store.commit('checkout/setCheckoutLoaded', true);
  },
  methods: {
    updateLineQuantity(qty, rowId, amount) {
      this.itemUpdateQueue[rowId] = qty
      CheckoutApi.cancelGetCart()
      this.updateCart(amount)
    },
    updateCart: _.debounce(async function (amount) {
      this.$store.commit('checkout/setCheckoutLoaded', false);

      await Object.keys(this.itemUpdateQueue).map(key => {
        return {
          key,
          product: {
            qty: parseInt(this.itemUpdateQueue[key]),
          },
        }
      }).reduce((promise, itemData) => {
        this.$forceUpdate()

        return promise.then(() => CheckoutApi
          .updateCart(itemData)
          .then(() => {
            delete this.itemUpdateQueue[itemData.key]
          })
          .finally(() => {
            const product = this.items.find(product => product.rowId === itemData.key);

            if (undefined !== typeof product) {
              if (amount > 0) {
                this.onProductCountIncreased(product.name);
              } else {
                this.onProductCountDecreased(product.name);
              }
            }
          })
        )
      }, Promise.resolve())

      this.$emit('update-qty')
    }, 1000),
    removeLine(rowId) {
      this.$store.commit('checkout/setCheckoutLoaded', false);
      this.$forceUpdate();

      CheckoutApi.removeProductRow(rowId)
        .then(() => {
          this.$emit('remove-line')

          const product = this.items.find(product => product.rowId === rowId);
          if (undefined !== typeof product) {
            this.onProductRemovedFromCart(product.name);
          }
        })
        .catch((error) => {
          this.$handleError(error)
        });
    }
  },
  computed: {
    isCheckoutLoaded() {
      return this.$store.state.checkout.isCheckoutLoaded;
    },
    isTaxesCalculated() {
      return this.$store.state.checkout.isTaxesCalculated
    },
    isLoadingTaxes() {
      return this.$store.state.checkout.isLoadingTaxes
    }
  },
  props: {
    items: Array,
  }
})
;
</script>
